module.exports = __webpack_public_path__ + "img/dean.ffd005c7.jpg";